import Vue from 'vue';
import gaService from './ga.service';

export default {
    async getAllBalances() {
        return (await Vue.http.get('/api/balance/getall')).data;
    },
    async getActiveBalance() {
        return (await Vue.http.get('/api/balance')).data;
    },
    async getBalanceAsync(balanceId) {
        return (await Vue.http.get(`/api/balance/${balanceId}`)).data;
    },
    async activate(balanceId) {
        return (await Vue.http.post('/api/balance/activate', { balanceId: balanceId })).data;
    },
    async withdraw(amount, branch, metadata) {
        var withdrawResult = (await Vue.http.post('/api/balance/withdraw', { amount, branch, metadata })).data;
        if (withdrawResult.isSuccess) {
            gaService.send('pins', 'withdrawal', withdrawResult.playerName, withdrawResult.pin.value);
        }
        return withdrawResult;
    },
    async withdrawChangedBonusBalance(options) {
        return (await Vue.http.post('/api/mbk/mvb/withdraw/request/', options)).data;
    },
    async getBonuses() {
        return (await Vue.http.get('/api/balance/bonuses')).data;
    },
    async getBonusBalance() {
        return (await Vue.http.get('/api/balance/bonuses/balance')).data;
    },
    async requestWithdrawalAsync(options) {
        return (await Vue.http.post(`/api/balance/${options.balanceId}/withdrawal/approval/request`, options)).data;
    },
    async returnApprovedWithdrawalAsync(options) {
        return (await Vue.http.post(`/api/balance/${options.balanceId}/withdrawal/approved/return`, options)).data;
    },
    async returnRequestedWithdrawalAsync(options) {
        return (await Vue.http.post(`/api/balance/${options.balanceId}/withdrawal/requested/return`, options)).data;
    },
    async unlockWithdrawal() {
        return (await Vue.http.post('/api/balance/withdraw/unlock')).data;
    },
    async completeSession() {
        return (await Vue.http.post('/api/balance/session/complete')).data;
    },
    async revealAll() {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve({ amount: 137, bonus: 1.5 }), 3000);
        });
    },
    async transfer(fromBalance, toBalance) {
        return (await Vue.http.post('/api/balance/transfer', { fromBalance, toBalance })).data;
    }
};



// WEBPACK FOOTER //
// ./_common/services/balance.service.js